'use client'

import { useState } from 'react'
import { CompanyContent as CompanyContentType } from '@/types/company'
import { Box, Stack, Heading, Img, Text, AspectRatio } from '@/components/Chakra'
import { ImagePopup } from '@/components/ImagePopup'

type Props = {
  companyContent: CompanyContentType
}

export const CompanyContent = ({ companyContent }: Props) => {
  const imageHeights: { [key in number]: any } = {
    1: 540,
    2: 385,
    3: 243,
  }

  const imageAspects: { [key in number]: any } = {
    1: 2 / 1,
    2: 1 / 1,
    3: 1 / 1,
  }
  const [selectedImage, setSelectedImage] = useState<string>()

  return (
    <Box my={12}>
      <Heading mb={4} as={'h2'} fontSize={'xl'}>
        {companyContent.title}
      </Heading>
      <Text whiteSpace={'pre-wrap'}>{companyContent.body}</Text>
      {companyContent.images.length >= 1 && (
        <Stack mt={8} direction={'row'} spacing={[5, 5, 10]}>
          {companyContent.images.map((image) => {
            return (
              <AspectRatio
                key={image.id}
                ratio={imageAspects[companyContent.images.length]}
                overflow={'hidden'}
                borderRadius={'md'}
                w={'100%'}
              >
                <Img
                  borderRadius={'md'}
                  w={'100%'}
                  maxH={imageHeights[companyContent.images.length]}
                  objectFit={'cover'}
                  src={image.url}
                  alt={''}
                  cursor={'pointer'}
                  onClick={() => {
                    setSelectedImage(image.url)
                  }}
                />
              </AspectRatio>
            )
          })}
        </Stack>
      )}
      <ImagePopup
        imageUrl={selectedImage}
        onClose={() => {
          setSelectedImage(undefined)
        }}
      />
    </Box>
  )
}
